import { render, staticRenderFns } from "./Noticia.vue?vue&type=template&id=31b44132&scoped=true&lang=pug&"
import script from "./Noticia.vue?vue&type=script&lang=js&"
export * from "./Noticia.vue?vue&type=script&lang=js&"
import style0 from "./Noticia.styl?vue&type=style&index=0&id=31b44132&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b44132",
  null
  
)

export default component.exports